import { FormField } from './FormField'

export type FormProps = {
  id?: string
  title: string
  description: string
  category: string
  formFields: FormField[]
  repeating: string
  createdBy?: string
  createdAt?: Date
  updatedAt?: Date
}

export class Form {
  private readonly _id: string | undefined

  private _title: string
  private _description: string
  private _category: string
  private _formFields: FormField[]
  private _repeating: string
  // Auditoria: la sella el backend, aqui es solo de lectura.
  private readonly _createdBy: string | undefined
  private readonly _createdAt: Date | undefined
  private readonly _updatedAt: Date | undefined

  constructor(p: FormProps) {
    this._id = p.id
    this._title = p.title
    this._description = p.description
    this._category = p.category
    this._formFields = p.formFields
    this._repeating = p.repeating
    this._createdBy = p.createdBy
    this._createdAt = p.createdAt
    this._updatedAt = p.updatedAt
  }

  get createdBy(): string | undefined {
    return this._createdBy
  }

  get createdAt(): Date | undefined {
    return this._createdAt
  }

  get updatedAt(): Date | undefined {
    return this._updatedAt
  }

  get id(): string | undefined {
    return this._id
  }

  get title(): string {
    return this._title
  }

  set title(value: string) {
    this._title = value
  }

  get description(): string {
    return this._description
  }

  set description(value: string) {
    this._description = value
  }

  get category(): string {
    return this._category
  }

  set category(value: string) {
    this._category = value
  }

  get repeating(): string {
    return this._repeating
  }

  set repeating(value: string) {
    this._repeating = value
  }

  get formFields(): FormField[] {
    return [...this._formFields]
  }

  addFormField(value: FormField) {
    this._formFields.push(value)
  }

  removeFormField(id: string) {
    this._formFields = this._formFields.filter((ff) => ff.id !== id)
  }
}
